import { useState } from "react";
import MainHeader from "./MainHeader";
import { PillRadio } from "components/radio";
import { Container, Nav, Navbar } from "react-bootstrap";
import { tabItems } from "constants";

import "./header.css";
import { useLocation } from "react-router-dom";

function TopHeader() {
  const location = useLocation();
  const { pathname } = location;
  const [tab, setTab] = useState(0);

  return (
    <div className="bg-white">
      <div className="container p-0">
        <div className="w-100 d-inline-flex justify-content-between horizontal-line pb-1">
          <div className="pt-2">
            <PillRadio items={tabItems} setTab={setTab} active={tab} />
          </div>
          <div>
            <Navbar expand="lg" className="bg-white d-none d-lg-block">
              <Container>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="me-auto">
                    <Nav.Link href="/news" active={pathname === "/news"}>
                      News
                    </Nav.Link>
                    <Nav.Link href="/contact" active={pathname === "/contact"}>
                      Contact Us
                    </Nav.Link>
                    <Nav.Link
                      href="/location"
                      active={pathname === "/location"}
                    >
                      Location
                    </Nav.Link>
                    <Nav.Link href="/global" active={pathname === "/global"}>
                      Global Site
                    </Nav.Link>
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
          </div>
        </div>
      </div>
      <MainHeader />
    </div>
  );
}

export default TopHeader;
